import React, { useState } from 'react'
import { createSelector } from 'reselect'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Chip } from '@material-ui/core'
import CurrencyFormat from 'react-currency-format'
import { useParams } from 'react-router'

import './style.scss'

//HELPERS
import { stringToSlug, capitalizeFirstLetter } from '../../utils/helpers'

//REDUX
import {
  makeSelectHasSlug,
  makeSelectAgency,
} from '../../redux/ducks/experiences'
import { makePosition } from '../../redux/ducks/position'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { fontSize } from '@material-ui/system'

const stateSelector = createSelector(
  [makeSelectHasSlug, makeSelectAgency, makePosition],
  (hasSlug, agency, position) => ({
    hasSlug,
    agency,
    position,
  }),
)

const ExperienceCard = ({ experience, isMock, isOpen, slugAgency }) => {
  const { slug, agencyId } = useParams()
  const { hasSlug, agency, position } = useSelector(stateSelector)
  const [distance, setDistance] = useState('')
  console.log(experience)
  const {
    principalImage,
    category,
    name,
    description,
    valuePerPerson,
    key: experienceId,
    agencyKey,
    shortDescription,
    agencyName,
    locator,
    type,
    seo,
  } = experience
  //TODO HACER AQUI
  // if (!!locator) {
  //   // const origen = `${position.position.lat},${position.position.lng}`
  //   // const destino = `${locator.geometry.lat},${locator.geometry.lng}`
  //   if (!!locator.geometry && !!position.position.lat) {
  //     // const origen = `${position.position.lat},${position.position.lng}`
  //     // const destino = `${locator.geometry.lat},${locator.geometry.lng}`
  //     // const url =
  //     //   'https://maps.googleapis.com/maps/api/distancematrix/json?key=AIzaSyBAnpypKIEUAdjAoFNR4iuCplgVaHdAIoY'
  //     // axios
  //     //   .get(`${url}&origins=${origen}&destinations=${destino}`)
  //     //   .then((res) => {
  //     //     // console.log("POS",origen, "Locator", destino)
  //     //     setDistance(res.data.rows[0].elements[0].distance.text)
  //     //   })
  //   }
  //   // ""
  // }

  const useStyles = makeStyles((theme) => ({
    imgContainer: {
      backgroundImage: `url(${principalImage})`,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      borderTopRightRadius: '15px',
      borderTopLeftRadius: '15px',
      width: '100%',
      height: '200px',
    },
    chipStyle: {
      backgroundColor: isOpen ? '#3ab753' : '#b73a3a',
      color: '#ffffff',
      fontWeight: 'bold',
    },
  }))
  const classes = useStyles()

  const typePrice = () => {
    if (category === 'HOTEL') {
      return ' por noche'
    } else {
      return ' por reserva'
    }
  }

  const handleRedirect = () => {
    if (slug) {
      return `/marketplace/${slug}/${experience.agencyKey}/${
        experience.key
      }/${stringToSlug(experience.name)}`
    } else {
      let url = ''

      if (!!seo && !!slugAgency) {
        url = `/${slugAgency}/${seo.slug}`
      } else {
        url = agencyId
          ? `/${agencyId}/${experienceId}/${stringToSlug(experience.name)}`
          : `/${agencyKey}/${experienceId}/${stringToSlug(experience.name)}`
      }
      return url
    }
  }

  return (
    <>
      {type === 'PXQ' && <div className="cucarda">Precio por cantidad</div>}
      {type === 'PXH' && <div className="cucarda">Precio por hora</div>}
      {type === 'PXO' && <div className="cucarda">Precio por ocupación</div>}
      <div className="cardExperience">
        {isMock ? (
          <div className="cardContainer">
            <LazyLoadImage src={principalImage} className="img" />
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={1}
            >
              <h3
                style={{
                  margin: '0',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {capitalizeFirstLetter(name)}
              </h3>
              {category === 'RESTAURANT' && (
                <Chip
                  size="small"
                  className={classes.chipStyle}
                  label={isOpen ? 'Abierto' : 'Cerrado'}
                />
              )}
            </Box>

            <p className="despcription line-clamp">
              {shortDescription
                ? capitalizeFirstLetter(shortDescription).slice(0, 125) + '...'
                : capitalizeFirstLetter(description).slice(0, 125) + '...'}
            </p>

            {category !== 'RESTAURANT' && (
              <>
                <CurrencyFormat
                  value={valuePerPerson}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                  className="price"
                />
                <span>{typePrice()}</span>
              </>
            )}
          </div>
        ) : (
          <Link
            style={{ textDecoration: 'none', color: 'black' }}
            to={handleRedirect()}
          >
            <div className="cardContainer">
              <LazyLoadImage src={principalImage} className="img" />
              <div className="content-card">
                <div className="principalContent">
                  <h1
                    style={{
                      whiteSpace: 'nowrap',
                      fontSize: '18px',
                    }}
                  >
                    {capitalizeFirstLetter(name)}
                  </h1>

                  {category === 'RESTAURANT' && (
                    <Chip
                      size="small"
                      className={classes.chipStyle}
                      label={isOpen ? 'Abierto' : 'Cerrado'}
                    />
                  )}

                  <h2
                    style={{
                      display: 'block',
                      fontSize: '15px',
                    }}
                  >
                    {capitalizeFirstLetter(agencyName)}{' '}
                    {/* <small style={{ color: '#673AB7' }}>
                  {distance ? ' - Estás a ' + distance : ''}
                </small> */}
                  </h2>
                </div>

                <p className="despcription line-clamp">
                  {shortDescription
                    ? capitalizeFirstLetter(shortDescription).slice(0, 125) +
                      '...'
                    : capitalizeFirstLetter(description).slice(0, 125) + '...'}
                </p>

                {category !== 'RESTAURANT' && category !== 'ECOMMERCE' && (
                  <div className="price-container">
                    {experience.type === 'PXQ' ||
                    experience.type === 'PXH' ||
                    experience.type === 'PXO' ? (
                      <p className="from-text">Desde</p>
                    ) : null}
                    <div className="price">
                      <CurrencyFormat
                        value={
                          experience && experience.type === 'PXH'
                            ? experience.pricePerHour?.[0]?.price ||
                              experience.pricePerOcupation?.[0]?.price ||
                              experience.priceQuantity?.[0]?.price
                            : experience && experience.type === 'PXO'
                            ? experience.pricePerHour?.[0]?.price ||
                              experience.pricePerOcupation?.[0]?.price ||
                              experience.priceQuantity?.[0]?.price
                            : experience && experience.type === 'PXQ'
                            ? experience.pricePerHour?.[0]?.price ||
                              experience.pricePerOcupation?.[0]?.price ||
                              experience.priceQuantity?.[0]?.price
                            : experience?.valuePerPerson
                        }
                        displayType="text"
                        thousandSeparator
                        prefix="$"
                        className="pricecard"
                      />
                      <span className="additional-info">{typePrice()}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Link>
        )}
      </div>
    </>
  )
}

export default ExperienceCard
